const decorativeMap: {
  [key: string]: { positionDesktop: string; positionSmallDesktop };
} = {
  'graphic-1': {
    positionDesktop: '-16px 50%',
    positionSmallDesktop: '-16px 50%',
  },
};

export const getDecorativeImage = (
  decorative: string,
): { desktop: string; smallDesktop: string } => {
  const baseUrl = `/images/decorative-creative-split-hero/${decorative.toLowerCase()}`;
  return {
    desktop: `url(${baseUrl}-desktop.svg)`,
    smallDesktop: `url(${baseUrl}-small-desktop.svg)`,
  };
};

export const getDecorativePosition = (
  decorative: string,
): { desktop: string; smallDesktop: string } => {
  const position = decorativeMap[decorative.toLowerCase()];
  return {
    desktop: position.positionDesktop,
    smallDesktop: position.positionSmallDesktop,
  };
};
